module.exports = __webpack_public_path__ + "static/media/google-play.736b4b04.png";